<template>
    <v-card variant="elevated" :title="t('customers')" class="mx-auto dash-card" width="200">
        <template v-slot:append>
            <svg-icon type="mdi" :path="mdiAccountStar" class="mr-2"></svg-icon>
        </template>
        <v-card-text>    
            <p>{{ userMessage }}</p>
        </v-card-text>
    </v-card>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAccountStar } from '@mdi/js';
import { useI18n } from 'vue-i18n';

const store = useStore();
const customersStatistics = ref({ totalCustomers: 0 });

const { t } = useI18n(); // i18n instance for translations

onMounted(async () => {
    await store.dispatch('dashboard/fetchDashboardStatistics'); // Fetch statistics on component mount
    customersStatistics.value = store.state.dashboard.dashboardStatistics; // Bind the statistics
});

// Here's the computed property for the user message
const userMessage = computed(() => {
    const currentUserRole = localStorage.getItem('role'); // Get the role from local storage
    const { totalCustomers } = customersStatistics.value;

    // Conditional message based on role and user count
    if (currentUserRole === 'super') {
        if (totalCustomers === 1) {
            return `${t('one')} ${t('customer')}`;
        } else {
            return `${totalCustomers} ${t('customers')}`;
        }
    } else {
        if (totalCustomers === 1) {
            return `${t('one')} ${t('customer')}.`;
        } else {
            return `${totalCustomers} ${t('customers')}.`;
        }
    }
});
</script>

<style scoped>

a {
    text-decoration: none; /* Ensure no underline on the text */
    display: inline-block; /* Block elements for card */
    width: 100%; /* Full width for the card */
}

.dash-card {
    border-radius: 8px;
    padding: 3px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    text-decoration: none;
    transition: transform 0.2s;
    cursor: pointer;
}
</style>